import Animation from 'Modules/Animation';

document
  .querySelectorAll('.menu-item-has-children .toggle-footer-sub-menu')
  .forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      Animation.slideToggle(toggle.parentNode.querySelector('.sub-menu'));
    });
  });
